export default {
    List: 'list',
    Entity: 'entity',
    Relation: 'relation',
    Record: 'record',
	Planning: 'planning',
    Login: 'login',
    Registration: 'registration',
    Module: 'module',
    Table: 'table',
    Scheduler: 'scheduler',
    Settings: 'settings',
    Profile: 'profile'
}
